<i class="fas fa-circle-notch fa-spin fa-fw" [ngClass]="sizeClass"></i>
